import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import styled from 'styled-components'

class Hola extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({ height: window.innerHeight })
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({ width: window.innerWidth })
        }
    }


    componentDidMount() {
        this.setState({ height: window.innerHeight, width: window.innerWidth })
        window.addEventListener('resize', this.updateDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;            
            background-color: #c1eb18;
            background-size: cover;
            background-repeat: no-repeat;
            padding: 100px 0;
            @media (min-width:1401px) and (max-width:1600px) {
              font-size: 60px;
              padding: 100px 0 50px 0;
          }
              @media (min-width:768px) and (max-width:1400px) {
              font-size: 60px;
              padding: 200px 0;
          }
            @media (max-width:767px) {
              padding: 100px 0;
          }
        `

        const Overlay = styled.div`
            width: 100%;
            display: flex;
            align-items: center;
            
        `

        const Heading3 = styled.h3`
            font-size: 60px;
            font-family: Poppins;
            line-height: 60px;
            color: #fff;
            margin: 30px 0 30px 0;
            font-weight: bold;            
            @media (min-width:768px) and (max-width:1500px) {
                font-size: 60px;
            }
            @media (max-width:767px) {
                font-size: 24px;
                line-height: 28px;
                margin-left: 2px;
                margin: 10px 0;
            }
        `

        const Heading2 = styled.h2`
            font-size: 120px;
            font-family: Poppins;
            line-height: 120px;
            color: #000;
            margin: 30px 0 30px 0;
            font-weight: bold;
            text-transform: uppercase;
            text-align: left;          
            @media (max-width:767px) {
                margin-left: 2px;
            }
            @media (min-width:768px) and (max-width:1400px) {
                font-size: 100px;
                margin: 130px 0 30px 0;
            }
            @media (max-width:767px) {
                font-size: 36px;
                line-height: 36px;                
                margin: 100px 0 20px 0;
            }
        `

        const Color = styled.span`
            color:  #000;            
        `

        const Content = styled.div`
            position: relative;
            z-index: 10
        `

        const Text = styled.p`
          font-size: 24px;          
          font-weight: 300;
          color: #1a1a1a;
          margin-top: 10px;
          @media (max-width:767px) {
            font-size: 16px;
            margin-bottom: 10px;
        }
        `
        const H3 = styled.h3`
          font-size: 24px;          
          font-weight: bold;
          color: #1a1a1a;
          margin-top: 10px;
          @media (max-width:767px) {
            font-size: 16px;
            margin-bottom: 10px;
        }
        `
        const TextaSpan = styled.a`        
            color: #ffffff;
            font-size: 50px;            
            line-height: 60px;
            transition: .5s;
            font-weight: bold;
            text-align: center;
            font-family: roboto,sans-serif;            
            display: block; /* o inline-block */
            margin: 60px auto 80px auto;
            width: fit-content;
                &:hover {
                    color: #1a1a1a;
                    text-decoration: none;
                    }
            @media (max-width: 767px) {
                font-size: 30px;
                line-height: 40px;
                margin: 20px auto 50px auto;                        
                }
            @media (min-width:768px) and (max-width:1500px) {                
                margin: 40px auto 130px auto;
                } 
        `

        return (
            <Section id="llamenos">
                <Overlay style={{ height: `${this.state.width > 500 ? this.state.height : 350}px` }}>
                    <Container>
                        <Content>
                            <Row>
                                <Col md={12}>
                                    <Heading2>
                                        <Color>Conectémonos</Color>
                                    </Heading2>
                                </Col>
                                <Col md={12}>
                                    <Heading3>
                                        Colombia +57 310 276 76 75
                                    </Heading3>
                                </Col>
                                <Col md={12}>
                                    <Heading3>
                                        USA +1 (786) 723 5100
                                    </Heading3>
                                </Col>
                                <Col md={12}>
                                    <Text>
                                        HORARIO DE VENTAS: Lunes a Viernes de 8:00am a 12:00m y de 2:00pm a 6:00pm - UTC/GMT -5
                                    </Text>
                                    <H3>
                                        ¿Listo para mejorar tu infraestructura digital?
                                    </H3>
                                    <Text>
                                        Contáctanos hoy para una cotización personalizada. Nuestro equipo de atención al cliente, disponible
                                        en Colombia y EE. UU., está listo para ayudarte.
                                    </Text>
                                    <Text>
                                        <b>¿Prefieres WhatsApp? ¡Genial! Escríbenos ahora.</b>
                                    </Text>
                                </Col>
                                <Col md={12}>
                                    <TextaSpan href="https://api.whatsapp.com/send?phone=573102767675"
                                        rel="nofollow"
                                        target="_blank"
                                        onClick={() => {
                                            console.log('Clic en WhatsApp VPS contacto, enviando evento');
                                            if (window.gtag) {
                                                window.gtag('event', 'click_whatsapp_vps.contacto', {
                                                    button_name: 'WhatsApp VPS Contacto Texto',
                                                    destination_url: 'https://api.whatsapp.com/send?phone=573102767675'
                                                });
                                            }
                                        }}>Contacta por WhatsApp
                                    </TextaSpan>
                                </Col>
                            </Row>
                        </Content>
                    </Container>
                </Overlay>
            </Section>
        )
    }
}

export default Hola